import { SET_SERVICE_REQUEST_DETAIL } from './service-request-detail'

export { SET_SERVICE_REQUEST_DETAIL }
